var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:whatsapp-icon",
    clipPath: "url(#clip0_572_18851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.1007 12.3026C1.10014 14.319 1.62702 16.288 2.62888 18.0234L1.00488 23.9529L7.07298 22.3618C8.75133 23.2755 10.6318 23.7543 12.5427 23.7544H12.5478C18.8561 23.7544 23.9913 18.6211 23.994 12.3116C23.9952 9.25421 22.8056 6.37924 20.6443 4.21626C18.4834 2.05347 15.6094 0.861747 12.5473 0.860352C6.23819 0.860352 1.10339 5.99337 1.10079 12.3026",
    fill: "url(#paint0_linear_572_18851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.692308 12.2988C0.691657 14.3878 1.23742 16.4272 2.27501 18.2248L0.592773 24.3668L6.87845 22.7187C8.61035 23.663 10.5603 24.1609 12.5445 24.1616H12.5496C19.0843 24.1616 24.4039 18.8437 24.4067 12.3083C24.4078 9.14105 23.1755 6.16272 20.937 3.92226C18.6982 1.68207 15.7214 0.447469 12.5496 0.446167C6.0138 0.446167 0.694913 5.76338 0.692308 12.2988ZM4.43556 17.9152L4.20087 17.5426C3.21426 15.9739 2.69352 14.1611 2.69426 12.2996C2.6964 6.86747 7.11724 2.44803 12.5533 2.44803C15.1859 2.44914 17.6599 3.47538 19.5208 5.33733C21.3815 7.19947 22.4054 9.67482 22.4048 12.3076C22.4024 17.7397 17.9814 22.1597 12.5496 22.1597H12.5457C10.7771 22.1587 9.04245 21.6837 7.5297 20.7862L7.1697 20.5727L3.43966 21.5506L4.43556 17.9151V17.9152Z",
    fill: "url(#paint1_linear_572_18851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.58581 7.34363C9.36386 6.85033 9.13027 6.84037 8.9192 6.83172C8.74637 6.82428 8.54879 6.82484 8.35139 6.82484C8.15381 6.82484 7.83279 6.89916 7.56144 7.19544C7.28981 7.492 6.52441 8.20865 6.52441 9.66623C6.52441 11.1239 7.58609 12.5326 7.73409 12.7304C7.88227 12.9279 9.78367 16.0148 12.795 17.2023C15.2977 18.1892 15.807 17.9929 16.3502 17.9434C16.8934 17.8941 18.1031 17.227 18.3499 16.5352C18.5969 15.8434 18.5969 15.2505 18.5228 15.1266C18.4488 15.0032 18.2512 14.929 17.9549 14.7809C17.6586 14.6327 16.202 13.916 15.9305 13.8171C15.6588 13.7183 15.4613 13.669 15.2638 13.9657C15.0662 14.2619 14.4988 14.929 14.3259 15.1266C14.1532 15.3247 13.9802 15.3493 13.684 15.2011C13.3876 15.0525 12.4334 14.74 11.3014 13.7308C10.4207 12.9455 9.82609 11.9757 9.65325 11.6791C9.48041 11.3829 9.63474 11.2223 9.7833 11.0747C9.91641 10.942 10.0797 10.7287 10.2279 10.5558C10.3757 10.3828 10.425 10.2594 10.5238 10.0618C10.6226 9.864 10.5732 9.69098 10.4992 9.54279C10.425 9.39461 9.84925 7.9294 9.58581 7.34363Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_572_18851",
    x1: 1150.46,
    y1: 2310.12,
    x2: 1150.46,
    y2: 0.860352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_572_18851",
    x1: 1191.29,
    y1: 2392.51,
    x2: 1191.29,
    y2: 0.446167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_18851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.82,
    height: 24,
    fill: "white",
    transform: "translate(0.589844 0.446167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.bc5acba5e0525c3d7770666dc73aa3ec.svg";
export { ForwardRef as ReactComponent };